export enum IdVerificationStatus {
  Unknown,
  Passed,
  Failed,
  Undetermined
}
